
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class OthersSelectGrid extends Serenity.EntityGrid<OthersRow, any> {
        protected getColumnsKey() { return 'OMS.Others'; }
        protected getDialogType() { return <any>OthersDialog; }
        protected getIdProperty() { return OthersRow.idProperty; }
        protected getLocalTextPrefix() { return OthersRow.localTextPrefix; }
        protected getService() { return OthersService.baseUrl; }
        //protected getInsertPermission() { return OthersRow.insertPermission; }
        //protected getUpdatePermission() { return OthersRow.updatePermission; }
        //protected getDeletePermission() { return OthersRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): OthersRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideOtherss && this.options.hideOtherss.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["OthersID" /* OthersID */], 'not in', [this.options.hideOtherss]]);
            return true;
           
        }
        
    }

    export interface OthersSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}